import ScrollReveal from 'scrollreveal';

export default {
    name         : 'scrollReveal',
    __id         : 'scrollReveal',
    _scrollReveal: null,
    _selector    : '[data-scroll-reveal]',
    elements     : null,
    init() {
        this.elements = document.querySelectorAll(this._selector);
        if (!this.elements.length) {
            return;
        }

        this._scrollReveal = new ScrollReveal();
        this._scrollReveal.reveal(this._selector, {
            distance: '32px',
            useDelay: 'onload',
            viewFactor: 0.05,
        });
    },
    reload() {
        return this.init();
    }
};